import styled from "styled-components";

export const ApplicationSummaryContinueButtonWrapper = styled.div`
    padding-top: 30px;
`;
